import React from "react";
import { Col, Modal, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const RedirectModal = (props) => {
    const { t } = useTranslation();
    const { onClose } = props;
    return (
        <Modal show={true} onHide={onClose}>
            <Modal.Header closeButton>
                <Modal.Title>{t("redirectModal.title")}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row>
                    <Col>
                        <p className="mb-3">{t("redirectModal.text")}</p>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Link to="/app" className="btn btn-outline-primary">
                            {t("goToAppPanel")}
                        </Link>
                    </Col>
                    <Col>
                        <Link to="/admin-app" className="btn btn-outline-primary">
                            {t("goToAdminAppPanel")}
                        </Link>
                    </Col>
                </Row>
            </Modal.Body>
        </Modal>
    );
};

export default RedirectModal;
